// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"cce3973f","320":"7e5898ad","720":"7e5898ad","893":"7e5898ad"}[chunkId] + ".chunk.css";
};